import { alpha } from '@mui/material';
import { styled } from '@mui/material/styles';
import { BodyText } from '../BodyText';
import { useTrialStatus } from '@/hooks/useTrialStatus';
import { Ellipsis } from '../Ellipsis';

const TrialText = styled(BodyText, {
  shouldForwardProp: property => property !== 'warningColor',
})<{ warningColor?: 'info' | 'warning' }>(({ theme, warningColor = 'info' }) => {
  const colorMap: Record<'info' | 'warning', string> = {
    info: alpha(theme.palette.common.white, 0.7),
    warning: theme.palette.warning.main,
  };

  return {
    fontSize: '14px',
    color: colorMap[warningColor],
    overflow: 'hidden',
    flex: 1,
    minWidth: 0,
  };
});

export const TrialStatus = () => {
  const { warningLevel, displayText } = useTrialStatus();

  return (
    <TrialText warningColor={warningLevel?.color}>
      <Ellipsis text={displayText ?? ''} />
    </TrialText>
  );
};
